<template>
  <div class="row course-lecture-item" v-if="lecture">
    <!-- position -->
    <div class="col align-self-center course-lecture-item__position-col typography--color-primary text-right">
      <span class="course-lecture-item__position">
        {{ position }}
      </span>
      <span class="course-lecture-item__drag-handle">
        <img src="/static/images/baseline-drag_handle-24px.svg" alt="drag handle">
      </span>
    </div>

    <!-- thumbnail -->
    <router-link :to="`${$route.path}/lectures/${lecture.id}`"
                 tag="div"
                 class="col-3 course-lecture-item__thumbnail-col text-center">
      <div class="course-lecture-item__thumbnail" :style="lectureThumbStyle"/>
    </router-link>

    <!-- info -->
    <router-link :to="`${$route.path}/lectures/${lecture.id}`"
                 tag="div"
                 class="col course-lecture-item__info-col">
      <div class="typography--body-1 typography--font-weight-600 mb-1 course-lecture-item__title">
        {{ lecture.title }}
      </div>

      <div class="typography--caption typography--color-secondary" v-if="domainName || domainConceptName">
        <small>
          {{ domainName }} {{ domainConceptName }}
        </small>
      </div>

      <div class="typography--caption typography--color-secondary">
        <small>
          {{ getGradeLabel(lecture) }}
          {{ getSubjectLabel(lecture) }}
          - {{ getShareLevelLabel(lecture.share_level || 2) }}
        </small>
      </div>

      <div class="typography--caption break-word-all" v-if="lectureDescription">
        <small v-html="lectureDescription"/>
      </div>

      <div class="typography--caption typography--color-disabled" v-else>
        <small>
          {{ $t('common.terms.no_description') }}
        </small>
      </div>  
    </router-link>

    <div class="col align-self-center course-lecture-item__menu-col">
      <IconDropdown>
        <b-dropdown-item class="dropdown-item" :to="`${$route.path}/lectures/${lecture.id}/edit`">
          {{ $t('video_lectures.video_lecture.edit') }}
        </b-dropdown-item>
      </IconDropdown>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { get } from 'lodash';
  import labels from '@/mixins/labels';
  import { AWS_CF_URL } from '@/config';

  export default {
    name: 'course-lecture-item',

    mixins: [
      labels,
    ],

    props: {
      lecture: {
        type: Object,
        default: null,
      },
      position: {
        type: Number,
        default: 0,
      },
      domainConcepts: {
        type: Object,
        default: null,
      },
      domainName: {
        type: String,
        default: '',
      },
    },

    computed: {
      ...mapGetters([
        'subjectMap',
        'gradeMap',
      ]),

      lectureThumbLink() {
        const defaultLink = `${AWS_CF_URL}/uploads/cover_images/ESC.png`;

        return get(this.lecture, 'video.pictures[1].link', defaultLink);
      },

      lectureThumbStyle() {
        return {
          'background-image': `url('${this.lectureThumbLink}')`,
        };
      },

      lectureDescription() {
        if (this.lecture && this.lecture.description) {
          return this.lecture.description.replace(/\n/g, '<br>');
        }

        return null;
      },

      domainConceptName() {
        if (this.domainConcepts && this.lecture) {
          return get(this.domainConcepts[this.lecture.domain_concept_id], 'name', '');
        }

        return '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .course-lecture-item {
    .course-lecture-item__drag-handle {
      display: none;

      &:hover {
        cursor: grab;
      }

      &:active {
        cursor: grabbing;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);

      .course-lecture-item__position {
        display: none;
      }

      .course-lecture-item__drag-handle {
        display: inline;
      }
    }

    .course-lecture-item__position-col {
      flex: 0 0 36px;
      max-width: 36px;
    }

    .course-lecture-item__thumbnail-col,
    .course-lecture-item__info-col {
      padding-top: 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      cursor: pointer;
    }

    .course-lecture-item__menu-col {
      flex: 0 0 50px;
      max-width: 50px;
    }

    .course-lecture-item__thumbnail {
      height: 68px;
      background-color: #f7f7f7;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .course-lecture-item__title {
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* number of lines to show */
      max-height: 40px;    /* fallback */
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/video-courses/components/CourseLectureItem.vue